import React from 'react'
import clsx from 'classnames'
import type { ContactsPage as ContactsPageData } from 'api/api.types'
import { formatPhone } from 'utils/formatPhone'
import styles from './ContactsPage.module.scss'

type ContactsBlockData = ContactsPageData['templateVars']['pageVars']['blocks'][number]

const ContactsBlock: React.FC<{ block: ContactsBlockData }> = ({ block }) => {
  // The CMS field holds several phones separated by commas, in any format
  const phones = block.phone.split(',').map((phone) => phone.replace(/\D/g, ''))
  const icon = block.icon?.image?.[0]?.path

  return <div className={styles.block} itemScope itemType={'http://schema.org/Organization'}>
    <div className={styles.blockIcon}>
      <img className={styles.icon} src={icon} alt="icon" />
    </div>
    <div className={styles.blockContent}>
      <div itemProp={'name'} className={styles.blockTitle}>{block.title}</div>
      {phones.map((phone, index) => (
        <div key={index} itemProp={'telephone'} className={styles.phone}>
          <a href={`tel:+${phone}`}>{formatPhone(phone)}</a>
        </div>
      ))}
      <div itemProp={'email'} className={clsx([styles.email, styles.info])}>
        {block.email}
      </div>
      <div>
        <div itemProp={'address'} className={clsx([styles.email, styles.info])}>{block.address}</div>
        <div className={clsx([styles.schedule, styles.info])}>{block.schedule}</div>
      </div>
      {!!block.comments?.length && <div className={clsx([styles.comment, styles.info])}>
        {block.comments}
      </div>}
    </div>
  </div>
}

type ContactsPageProps = {
  page: ContactsPageData,
}

export const ContactsPage: React.FC<ContactsPageProps> = ({ page }) => (
  <div className={styles.container}>
    <h1 className={styles.title}>{page.title}</h1>
    <div className={styles.blocks}>
      {page.templateVars.pageVars.blocks.map((block, index) => <ContactsBlock key={index} block={block} />)}
    </div>
  </div>
)
